import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  servers: [],
};

const serverStatusSlice = createSlice({
  name: "serverStatus",
  initialState,
  reducers: {
    setServerStatuses: (state, action) => {
      state.servers = action.payload;
    },
  },
});

export const { setServerStatuses } = serverStatusSlice.actions;
export default serverStatusSlice.reducer;
